export default __webpack_public_path__ + "static/media/profile1.ee5c44da.svg";